import React, { useState } from 'react';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const RECIPIENT_EMAIL = 'inquiry@phil.directory';

const PREFILL = "I would love to connect with you further regarding your professional background and experience!";

const ContactDialog = ({ open, onClose }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState(PREFILL);
  const [submitting, setSubmitting] = useState(false);
  const [result, setResult] = useState(null); // { ok, error }

  if (!open) return null;

  const reset = () => {
    setName(''); setEmail(''); setPhone(''); setMessage(PREFILL);
    setResult(null);
  };
  const handleClose = () => { reset(); onClose(); };

  const handleSubmit = async () => {
    if (!email || !message.trim()) {
      setResult({ ok: false, error: 'Please provide your email and a message.' });
      return;
    }
    setSubmitting(true);
    setResult(null);
    try {
      const res = await axios.post(`${API}/inquiries`, {
        name, email, phone, message,
      }, { timeout: 10000 });
      if (res.data && res.data.ok) {
        setResult({ ok: true });
      } else {
        setResult({ ok: false, error: 'Submission failed. Please email directly.' });
      }
    } catch (e) {
      setResult({ ok: false, error: 'Submission failed. Please email directly.' });
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="fixed inset-0 z-[70] flex items-center justify-center bg-black/35">
      <div
        className="bg-[#F5F5F5] border border-[#808080]"
        style={{ width: 'min(560px, 94vw)', fontFamily: 'Tahoma, Segoe UI, sans-serif', boxShadow: '0 8px 28px rgba(0,0,0,0.3)' }}
      >
        <div className="flex items-center justify-between h-[26px] bg-[#2B579A] text-white px-[8px]">
          <span className="text-[12px]">Contact / Inquiry</span>
          <button onClick={handleClose} className="w-[28px] h-[26px] hover:bg-[#E81123] flex items-center justify-center">
            <svg width="10" height="10" viewBox="0 0 10 10">
              <line x1="1" y1="1" x2="9" y2="9" stroke="#FFF" strokeWidth="1.2" />
              <line x1="9" y1="1" x2="1" y2="9" stroke="#FFF" strokeWidth="1.2" />
            </svg>
          </button>
        </div>

        <div className="p-[14px] text-[12px] text-black">
          {result && result.ok ? (
            <div className="border border-[#7BAA5C] bg-[#E8F5DD] p-[12px]">
              <div className="font-bold mb-[4px]">Inquiry submitted</div>
              <div className="text-[11.5px] leading-[1.5]">
                Thanks &mdash; your message has been recorded. Phillip will follow up at the email
                you provided. You can also reach him directly at{' '}
                <a className="text-[#2B579A] underline" href={`mailto:${RECIPIENT_EMAIL}`}>{RECIPIENT_EMAIL}</a>.
              </div>
            </div>
          ) : (
            <>
              <div className="text-[11.5px] text-[#444] mb-[10px] leading-[1.45]">
                Send a quick note. Submissions are recorded and forwarded to{' '}
                <a className="text-[#2B579A] underline" href={`mailto:${RECIPIENT_EMAIL}`}>{RECIPIENT_EMAIL}</a>.
              </div>

              <Field label="Your name" value={name} onChange={setName} placeholder="Jane Doe" />
              <Field label="Email" value={email} onChange={setEmail} placeholder="jane@example.com" required />
              <Field label="Phone" value={phone} onChange={setPhone} placeholder="(optional)" />
              <div className="flex items-start mb-[8px]">
                <div className="w-[90px] text-[12px] pt-[3px]">Message:</div>
                <textarea
                  value={message}
                  onChange={(e) => setMessage(e.target.value)}
                  className="flex-1 border border-[#8B8B8B] bg-white px-[6px] py-[4px] text-[12px] resize-none focus:outline-none focus:border-[#2B579A]"
                  rows={5}
                />
              </div>

              {result && !result.ok && (
                <div className="border border-[#D08080] bg-[#FFE8E8] text-[#900] p-[8px] text-[11.5px] mb-[6px]">
                  {result.error}
                </div>
              )}
            </>
          )}
        </div>

        <div className="flex justify-end gap-[6px] bg-[#F0F0F0] px-[12px] py-[10px] border-t border-[#D0D0D0]">
          {result && result.ok ? (
            <button onClick={handleClose} className="min-w-[80px] h-[24px] text-[12px] border border-[#2B579A] bg-[#DCE9F9] hover:bg-[#C1D7F0]">Close</button>
          ) : (
            <>
              <button
                onClick={handleSubmit}
                disabled={submitting}
                className="min-w-[80px] h-[24px] text-[12px] border border-[#2B579A] bg-[#DCE9F9] hover:bg-[#C1D7F0] active:bg-[#B0CEEC] disabled:opacity-60"
              >
                {submitting ? 'Sending...' : 'Send'}
              </button>
              <button onClick={handleClose} className="min-w-[80px] h-[24px] text-[12px] border border-[#707070] bg-[#F0F0F0] hover:border-[#2B579A] hover:bg-[#DCE9F9]">Cancel</button>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

const Field = ({ label, value, onChange, placeholder, required }) => (
  <div className="flex items-center mb-[8px]">
    <div className="w-[90px] text-[12px]">
      {label}{required && <span className="text-[#C00] ml-[2px]">*</span>}:
    </div>
    <input
      type="text"
      value={value}
      placeholder={placeholder}
      onChange={(e) => onChange(e.target.value)}
      className="flex-1 h-[22px] border border-[#8B8B8B] bg-white px-[6px] text-[12px] focus:outline-none focus:border-[#2B579A]"
    />
  </div>
);

export default ContactDialog;
